import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../store'; // Import AppDispatch
import { submitAgreement } from '../../thunks/submitAgreement';
import contractData, { ARTICLE_COUNT } from './contractData';
import * as S from './Styles';
import ArrowCircleLeft from '@mui/icons-material/ArrowCircleLeftOutlined';
import { Checkbox, FormControlLabel, Typography } from '@mui/material'; // Added Typography for error
import { blue, green } from '@mui/material/colors';
import Texts from '../Texts';

interface ContractProps {
  onPrevious: () => void;
  idedntty: 'personal' | 'legal';
}

const Contract: React.FC<ContractProps> = ({ onPrevious, idedntty }) => {
  const dispatch = useDispatch<AppDispatch>(); // Use typed AppDispatch
  const { identity, isSubmitting, error } = useSelector(
    (state: RootState) => state.unifiedForm,
  );
  const { id, display_name } = identity || {}; // Add fallback for identity
  const [isAccepted, setIsAccepted] = useState(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAccepted(event.target.checked);
  };

  const handleSubmit = () => {
    if (isAccepted && id !== undefined) {
      dispatch(submitAgreement(id.toString()));
    }
  };

  return (
    <S.Container>
      {error && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}
      {/* <S.ButtonContract
        variant="contained"
        startIcon={<S.Icon />}
        onClick={onPrevious}
        disabled={isSubmitting}
      >
        {Texts.Terms.returnIdentity}
      </S.ButtonContract> */}

      <S.Title variant="h6">{Texts.Terms.title}</S.Title>
      <S.Description variant="body1">{Texts.Terms.titleContent}</S.Description>
      <ContractContent />

      <ContractForm
        isAccepted={isAccepted}
        onCheckboxChange={handleCheckboxChange}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </S.Container>
  );
};

const ContractContent: React.FC = () => (
  <S.ContractBox>
    <S.ContractText>
      {contractData.map((text, index) => {
        const paragraphs = text.split('\n').map((line, idx) => (
          <span key={`${index}-${idx}`}>
            {line}
            <br />
          </span>
        ));
        return (
          <div key={index} style={{ marginBottom: '10px' }}>
            {paragraphs}
          </div>
        );
      })}
    </S.ContractText>
  </S.ContractBox>
);

interface ContractFormProps {
  isAccepted: boolean;
  onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

const ContractForm: React.FC<ContractFormProps> = ({
  isAccepted,
  onCheckboxChange,
  onSubmit,
  isSubmitting,
}) => (
  <S.FormContract>
    <FormControlLabel
      sx={{
        margin: 0,
        padding: 0,
      }}
      control={
        <Checkbox
          checked={isAccepted}
          onChange={onCheckboxChange}
          name="acceptTerms"
          color="primary"
          sx={{
            color: blue[800],
            '&.Mui-checked': {
              color: green[600],
            },
            paddingRight: 0,
          }}
        />
      }
      label={`${Texts.Terms.acceptTermsBefore}${ARTICLE_COUNT}${Texts.Terms.acceptTermsAfter}`}
    />

    <S.SubmitButtonBox>
      <S.SubmitButton
        type="button"
        startIcon={<ArrowCircleLeft />}
        disabled={!isAccepted || isSubmitting}
        onClick={onSubmit}
      >
        {isSubmitting ? 'در حال ارسال...' : Texts.Terms.submite}
      </S.SubmitButton>
    </S.SubmitButtonBox>
  </S.FormContract>
);

export default Contract;
